var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"taskProcess"},[(_vm.errmsg)?_c('div',{staticClass:"msg"},[_c('span',{staticClass:"msg-l"},[_vm._v(_vm._s(_vm.errmsg)+"111")]),_c('el-button',{on:{"click":_vm.revoke}},[_vm._v("返回首页")])],1):_vm._e(),(_vm.isQueue)?[_c('prePage',{on:{"revoke":_vm.revoke}})]:[_c('processAnimate',{on:{"revoke":_vm.revoke}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }